export const WEAK_PASSWORD_ERROR_MESSAGE =
  "This password is too weak and isn't allowed. Choose a stronger password that isn't commonly used to help keep your account secure."

export const PREVIEW_AUTH_HEADER_NAME = 'X-Preview-Auth'

/**
 * The name of the HTTP header that we send the site key in
 */
export const SITE_KEY_HEADER_NAME = 'X-Site-Key'

/**
 * Algolia florist search radius in meters - 15 miles (1 miles == 1.60934km)
 */
export const FLORIST_GEO_SEARCH_RADIUS_METERS = 15 * 1609

export const cssForPCCSkeleton = { xs: '212px', sm: '212px', md: '86px', lg: '86px', xl: '86px' }

export const blogCategories = [
  '/blog/all',
  '/blog/life',
  '/blog/news',
  '/blog/style',
  '/blog/wedding',
  '/blog/occasions',
  '/blog/types-of-flowers',
]

export const PRODUCT_QUERY_PARAMS = 'productQueryParams'

export const DELIVERY_PASS_EXISTS_ERROR = 'You already have an active delivery pass. It will be applied at checkout.'
export const DELIVERY_PASS_IN_CART_ERROR =
  'You already have a delivery pass in your basket. It will be applied at checkout.'

export const INTERFLORA_GOLD = 'INTERFLORAGOLD'
